module.exports = __webpack_public_path__ + "img/tableNoData.57514c47.png";